module.exports = __webpack_public_path__ + "img/searchusericon.6bbe3dd2.svg";